import { ChainId } from '@nominex/nomiswap-sdk'
import { wagmiConfig, wagmiAdapter, CHAINS } from './appkit.config'

// Re-export for backward compatibility
export { wagmiConfig, wagmiAdapter, CHAINS }

export enum CHAIN_MAP {
  // 'arbitrum' = ChainId.ARBITRUM,
  // 'avalanche' = ChainId.AVALANCHE,
  'bsc' = ChainId.BSC,
  'eth' = ChainId.ETHEREUM,
  // 'gnosis' = ChainId.GNOSIS,
  'matic' = ChainId.MATIC,
  // 'optimism' = ChainId.OPTIMISM,
}

// Legacy exports for backward compatibility (will be removed later)
export const wagmiClient = wagmiConfig
export const ethereumClient = null
